import type { PastAttempt } from "@brookbush/types";

import clsx from "clsx";

interface Props {
	attempt: PastAttempt;
}

const CourseExamPortalModalAttempt = ({ attempt }: Props) => {
	return (
		<tr className="border-y last:border-b-0">
			<td className="w-1/3 whitespace-nowrap px-3 py-1">
				{new Date(attempt.createdAt).toLocaleDateString("en-US", {
					dateStyle: "medium",
				})}
			</td>
			<td
				className={clsx(
					"w-1/3 px-3 py-1",
					attempt.isPassed === null
						? "bg-orange-50/50 text-orange-700 dark:bg-orange-300/10 dark:text-orange-300"
						: attempt.isPassed
							? "bg-emerald-50/50 text-emerald-700 dark:bg-emerald-300/10 dark:text-emerald-300"
							: "bg-red-50/50 text-red-700 dark:bg-red-300/10 dark:text-red-300",
				)}
			>
				{attempt.isPassed === null
					? "Incomplete"
					: attempt.isPassed
						? "Pass"
						: "Fail"}
			</td>
			<td className="w-1/3 px-3 py-1">
				{attempt.correctAnswers} / {attempt.totalQuestions} (
				{Math.floor(attempt.score).toFixed(0)}%)
			</td>
		</tr>
	);
};

export default CourseExamPortalModalAttempt;
